var ctrl = function($scope) {
  $scope.clear = function() {
    $scope.errors = {messages: null}
  };
  $scope.isString = function(x) {
    return _.isString(x);
  };

  // to pass in res.data instead of res.data.errors
  $scope.$watch('errors', function(x) {
    if (_.get(x, 'errors.messages')) {
      $scope.errors = x.errors;
    }
  })
};

ctrl.$inject = ['$scope'];

tiz.directive("formErrors", function() {
  return {
    scope: {
      errors: '='
    },
    controller: ctrl,
    templateUrl: require('../templates/form_errors.html')
  }
});
